export default {
    common: {
        appName: 'Swift Invoice',
        back: 'Kembali',
        cancel: 'Batal',
        email: 'Email',
        password: 'Kata sandi',
        or: 'atau',
        change: 'Ubah',
        delete: 'Hapus',
        save: 'Simpan',
        edit: 'Edit',
        add: 'Tambah',
        close: 'Tutup',
        date: 'Tanggal',
        total: 'Total',
        status: 'Status',
        amount: 'Jumlah',
        quantity: 'Kuantitas',
        rate: 'Tarif',
        tax: 'Pajak',
        discount: 'Diskon',
        note: 'Catatan',
        notes: 'Catatan',
        noData: 'Tidak ada data',
        description: 'Deskripsi',
        client: 'Klien',
        item: 'Item',
        items: 'Item',
        type: 'Jenis',
        category: 'Kategori',
        phone: 'Telepon',
        name: 'Nama',
        subject: 'Subjek',
        saveAndClose: 'Simpan dan Tutup',
        saveAndSendEmail: 'Simpan dan Kirim Email',
        sendEmail: 'Kirim email',
        send: 'Kirim',
        print: 'Cetak',
        moreActions: 'Tindakan lainnya',
        preparingPdf: 'Menyiapkan PDF...',
        pdfPreparationFailed: 'PDF tidak dapat disiapkan',
        warning: 'Peringatan',
        ok: 'OK',
        uploadSuccess: 'unggah berhasil',
        saveSuccess: 'simpan berhasil',
        deleteSuccess: 'hapus berhasil',
        deleteFailed: 'hapus gagal',
        saveFailed: 'simpan gagal',
        loadFailed: 'muat gagal',
        systemError: 'kesalahan sistem',
        sendSuccess: 'kirim berhasil',
        updateSuccess: 'pembaruan berhasil',
        unsavedChangesMsg: 'Anda memiliki perubahan yang belum disimpan. Apakah Anda ingin menyimpan atau membuangnya?',
        saveChangesTitle: 'Simpan perubahan?',
        confirmSave: 'Simpan',
        discard: 'Buang',
        validEmail: 'Silakan masukkan alamat email yang valid',
        deleteFailedMsg: 'hapus gagal',
        shipping: 'Pengiriman',
        attachment: 'Lampiran',
        days: 'Hari',
        excl: '(tidak termasuk)',
        incl: '(termasuk)',
        of: 'dari',
        batchActions: 'Tindakan massal',
        selected: 'dipilih',
        select: 'Pilih',
        batchDeleteConfirm: 'Hapus {count} data yang dipilih?',
        batchActionSuccess: '{count} data diperbarui',
        batchActionPartial: '{processed} diperbarui; {skipped} tidak perlu diubah',
        batchEmailInvalidRecipients: 'Tambahkan penerima valid untuk setiap dokumen',
        batchEmailSent: '{count} email terkirim',
        batchEmailPartial: '{sent} terkirim; {failed} gagal',
        emailHtmlNotAllowed: 'Subjek dan isi email tidak boleh berisi HTML.'
    },
    emailVerification: {
        title: 'Verifikasi email Anda',
        description: 'Kami mengirim kode verifikasi ke email login Anda:',
        codePlaceholder: 'Masukkan kode verifikasi',
        enterCode: 'Masukkan kode dari email untuk melanjutkan.',
        sent: 'Kode verifikasi telah dikirim.',
        resent: 'Kode verifikasi baru telah dikirim.',
        validFor: 'Kode berlaku selama 10 menit.',
        verify: 'Verifikasi',
        resend: 'Kirim ulang',
        success: 'Email terverifikasi. Email Anda akan dikirim sekarang.',
        failed: 'Kode verifikasi salah atau telah kedaluwarsa.',
        limitReached: 'Batas pengiriman hari ini telah tercapai.',
        remaining: 'Tersisa {count} pengiriman hari ini',
        contactUs: 'Hubungi kami'
    },
    login: {
        heroPrefix: 'Cerdas ',
        heroInvoicing: 'Penagihan',
        heroMiddle: ',',
        heroSimplified: 'Disederhanakan',
        heroSuffix: ' untuk Anda.',
        subtitle1: 'Buat, kirim, dan kelola faktur dengan mudah.',
        subtitle2: 'Dapatkan pembayaran lebih cepat dengan Swift Invoice.',
        feature1Title: 'Faktur Profesional',
        feature1Text: 'Buat faktur yang indah dalam hitungan menit',
        feature2Title: 'Pelacakan Real-time',
        feature2Text: 'Lacak pembayaran dan status faktur',
        feature3Title: 'Aman & Andal',
        feature3Text: 'Data Anda aman dengan keamanan tingkat enterprise',
        welcomeBack: 'Selamat datang kembali',
        signInToContinue: 'Masuk ke akun Anda untuk melanjutkan',
        enterEmail: 'Masukkan email Anda',
        enterPassword: 'Masukkan kata sandi Anda',
        rememberMe: 'Ingat saya',
        forgotPassword: 'Lupa kata sandi?',
        signIn: 'Masuk',
        signingIn: 'Sedang masuk…',
        continueWithGoogle: 'Lanjutkan dengan Google',
        continueWithApple: 'Lanjutkan dengan Apple',
        createAccount: 'Buat akun',
        startUsing: 'Mulai gunakan Swift Invoice',
        companyName: 'Nama perusahaan',
        enterCompanyName: 'Masukkan nama perusahaan Anda',
        alreadyHaveAccount: 'Sudah punya akun? Masuk',
        footerRights: '© 2026 Swift Invoice. Semua hak dilindungi.',
        termsOfService: 'Ketentuan Layanan',
        contactUs: 'Hubungi kami: goodinvoicego@gmail.com',
        betaDialogBody: 'Tim kami telah menyelesaikan versi pertama web <br> Versi ini hanya tersedia untuk pengguna iPhone <br> Kami akan menyempurnakan fungsi web secepat mungkin dan membukanya untuk semua <br>',
        ieDialogBody: 'Maaf, karena browser IE memiliki masalah kompatibilitas, kami belum mendukung browser IE saat ini, jika Anda perlu menggunakannya, silakan unduh',
        resetPasswordTitle: 'Setel ulang kata sandi',
        sendResetEmail: 'Kirim email setel ulang',
        resetEmailSent: 'Email setel ulang kata sandi telah dikirim. Silakan periksa kotak masuk Anda.',
        bindingTitle: 'Tautkan akun yang ada',
        bindingHintPrefix: 'Akun sudah menggunakan email ',
        bindingHintSuffix: '. Masukkan kata sandi akun tersebut untuk menautkan login Google Anda.',
        enterAccountPassword: 'Masukkan kata sandi akun',
        linkAccount: 'Tautkan akun',
        validEmail: 'Silakan masukkan alamat email yang valid',
        validPassword: 'Kata sandi harus 6 karakter atau lebih',
        validCompanyName: 'Silakan isi nama perusahaan Anda',
        companyNameTooLong: 'Nama perusahaan dapat berisi hingga {max} karakter',
        turnstileUnavailable: 'Pemeriksaan keamanan tidak dapat dimuat. Silakan coba lagi.',
        turnstileExpired: 'Pemeriksaan keamanan telah kedaluwarsa. Silakan selesaikan lagi.',
        accountDataLoadFailed: 'Akun telah diverifikasi, tetapi data bisnis tidak dapat dimuat. Silakan coba lagi.'
    },
    account: {
        title: 'Akun',
        profile: 'Profil',
        swiftAccount: 'Akun Swift Invoice',
        connectSocial: 'Hubungkan akun sosial',
        companyLogo: 'Logo perusahaan',
        logoSize: 'Ukuran logo',
        hideBusinessName: 'Sembunyikan nama bisnis',
        businessNameSize: 'Ukuran nama bisnis',
        sizeSmall: 'Kecil',
        sizeNormal: 'Normal',
        sizeBig: 'Besar',
        addLogo: 'Tambah logo',
        uploading: 'mengunggah...',
        currentPlan: 'Paket saat ini: Swift {plan}',
        planActiveUntil: 'Paket aktif hingga {date}',
        sharedWithMobile: 'Dibagikan dengan seluler',
        subscriptionExpired: 'Langganan Anda telah berakhir',
        planNote: 'Masuk kembali jika status langganan Anda belum diperbarui.',
        upgradeToPro: 'Tingkatkan ke Swift Pro',
        viewPlans: 'Lihat paket langganan',
        connecting: 'Menghubungkan…',
        connectGoogle: 'Hubungkan Google',
        googleConnected: 'Google terhubung',
        googleConnectedWithEmail: 'Google terhubung ({email})',
        connectApple: 'Hubungkan Apple',
        appleConnected: 'Apple terhubung',
        appleConnectedWithEmail: 'Apple terhubung ({email})',
        logoUuidMissing: 'UUID logo perusahaan hilang',
        googleConnectedToast: 'Akun Google terhubung.',
        appleConnectedToast: 'Akun Apple terhubung.',
        logoUploadEmpty: 'Pilih gambar.',
        logoUploadSize: 'Ukuran gambar tidak boleh melebihi 10 MB.',
        logoUploadType: 'Hanya gambar JPEG, PNG, dan BMP yang didukung.',
        logoUploadFailed: 'Logo perusahaan tidak dapat diunggah.',
        logoUnavailable: 'File logo tidak tersedia. Unggah kembali.',
        deleteAccount: 'Hapus akun',
        deleteAccountDescription: 'Tutup akun Swift Invoice Anda secara permanen.',
        deleteAccountTitle: 'Hapus akun?',
        deleteAccountWarning: 'Tindakan ini tidak dapat dibatalkan.',
        deleteAccountConfirm: 'Masukkan kata sandi untuk mengonfirmasi penghapusan akun.',
        deleteAccountPasswordPlaceholder: 'Masukkan kata sandi'
    },
    menu: {
        openNavigation: 'Buka navigasi',
        closeNavigation: 'Tutup navigasi',
        invoices: 'Faktur',
        estimates: 'Estimasi',
        purchaseOrders: 'Pesanan Pembelian',
        creditMemos: 'Memo Kredit',
        time: 'Waktu',
        items: 'Item',
        clients: 'Klien',
        expenses: 'Pengeluaran',
        reports: 'Laporan',
        settings: 'Pengaturan',
        companyInfo: 'Info perusahaan',
        taxes: 'Pajak',
        default: 'Default',
        customizeInvoice: 'Kustomisasi faktur',
        sendFeedback: 'Kirim Umpan Balik',
        newReply: '1 balasan baru',
        signOut: 'Keluar',
        signOutConfirm: 'Anda yakin ingin keluar?',
        addBusiness: 'Tambah bisnis',
        newBusinessTitle: 'Bisnis baru',
        businessName: 'Nama bisnis',
        businessNamePlaceholder: 'Masukkan nama bisnis',
        createBusiness: 'Buat',
        businessNameRequired: 'Masukkan nama bisnis',
        createBusinessSuccess: 'Bisnis berhasil dibuat',
        deleteBusiness: 'Hapus bisnis',
        deleteBusinessTitle: 'Hapus bisnis',
        deleteBusinessConfirm: 'Hapus “{name}”?',
        deleteBusinessWarning: 'Semua data milik bisnis ini akan dihapus.',
        deleteBusinessSuccess: 'Bisnis berhasil dihapus',
        trialDaysLeft: 'Sisa uji coba {days} hari',
        upgradeAccount: 'Tingkatkan akun'
    },
    network: {
        loginExpired: 'Sesi login telah berakhir, silakan masuk kembali',
        requestTimeout: 'Permintaan waktu habis, silakan periksa jaringan'
    },
    language: {
        label: 'Bahasa',
        zh: '中文',
        en: 'English'
    },
    invoice: {
        listLoadFailed: 'Faktur tidak dapat dimuat.',
        summaryLoadFailed: 'Total faktur tidak dapat dimuat.',
        invoiceNumberPlaceholder: 'Masukkan nomor faktur',
        filterAllClients: 'Semua klien',
        clientOptionsLoadFailed: 'Klien untuk penyaringan tidak dapat dimuat.',
        filterAllStatuses: 'Semua status',
        filterUnpaid: 'Belum dibayar',
        filterPaid: 'Lunas',
        filterOverdue: 'Jatuh tempo',
        filterUnsent: 'Belum dikirim',
        filterSent: 'Terkirim',
        filterStartDate: 'Tanggal mulai',
        filterEndDate: 'Tanggal selesai',
        searchPlaceholder: 'Cari faktur Anda',
        addInvoice: 'Tambah faktur',
        overdueInvoices: 'Faktur jatuh tempo',
        paidInvoices: 'Faktur dibayar',
        unpaidInvoices: 'Faktur belum dibayar',
        unsentInvoices: 'Faktur belum dikirim',
        columnNumber: 'Nomor',
        columnClient: 'Klien',
        columnStatus: 'Status',
        statusFullyPaid: 'Lunas',
        statusPartial: 'Sebagian',
        statusOverdue: 'Jatuh tempo',
        statusUnsent: 'Belum Dikirim',
        statusSent: 'Dikirim',
        statusOpened: 'Dibuka',
        actionRecordPayment: 'Catat Pembayaran',
        actionMarkAsSent: 'Tandai sebagai Dikirim',
        actionCopy: 'Salin',
        actionDelete: 'Hapus',
        copyDialogTitle: 'Salin faktur',
        copyTargetType: 'Salin ke',
        copyOptions: 'Opsi salinan',
        copyClient: 'Salin klien',
        copyItems: 'Salin item',
        copyAttachments: 'Salin lampiran',
        confirmDelete: 'Ini akan menghapus faktur. Lanjutkan?',
        copySuccess: 'Faktur disalin',
        copyFailed: 'Gagal menyalin',
        deleteSuccess: 'Faktur dihapus',
        deleteFailed: 'Gagal menghapus',
        recordPaymentDialogTitle: 'Catat Pembayaran',
        markAsFullyPaid: 'Tandai sebagai lunas',
        formAmount: 'Jumlah',
        formDate: 'Tanggal',
        formPaymentMethod: 'Metode Pembayaran',
        formNote: 'Catatan',
        allYears: 'Semua tahun',
        errorNoOutstandingBalance: 'Tidak ada saldo terutang yang dapat dibayar',
        errorInvalidPaymentAmount: 'Masukkan jumlah lebih besar dari nol dengan maksimal 5 angka desimal',
        dueDateToday: 'Hari ini',
        dueDateDaysAgo: '{days} hari lalu',
        dueDateInDays: 'dalam {days} hari'
    },
    estimate: {
        filterAllStatuses: 'Semua status',
        pageTitlePurchaseOrders: 'Pesanan Pembelian',
        pageTitleEstimates: 'Estimasi',
        pageTitleCreditMemos: 'Memo Kredit',
        searchPlaceholderPurchaseOrders: 'Cari pesanan pembelian Anda',
        searchPlaceholderEstimates: 'Cari estimasi Anda',
        searchPlaceholderCreditMemos: 'Cari memo kredit Anda',
        addPurchaseOrder: 'Tambah pesanan pembelian',
        addEstimate: 'Tambah estimasi',
        addCreditMemo: 'Tambah memo kredit',
        columnNumber: 'Nomor',
        columnClient: 'Klien',
        columnDate: 'Tanggal',
        columnEmail: 'Email',
        columnStatus: 'Status',
        columnTotal: 'Total',
        statusUnsent: 'Belum dikirim',
        statusSent: 'Dikirim',
        actionMarkAsSent: 'Tandai sebagai Dikirim',
        actionCopy: 'Salin',
        actionDelete: 'Hapus',
        actionConvertToInvoice: 'Ubah menjadi faktur',
        copyDialogTitle: 'Salin {document}',
        copyTargetType: 'Salin ke',
        copyOptions: 'Opsi salinan',
        copyClient: 'Salin klien',
        copyItems: 'Salin item',
        copyAttachments: 'Salin lampiran',
        confirmDelete: 'Ini akan menghapus {document}. Lanjutkan?',
        convertConfirm: 'Ubah {document} ini menjadi faktur? Tanggal akan diatur ke hari ini.',
        copySuccess: '{document} disalin',
        copyFailed: 'Gagal menyalin',
        convertSuccess: '{document} diubah menjadi faktur',
        convertFailed: 'Gagal mengubah',
        deleteSuccess: '{document} dihapus',
        deleteFailed: 'Gagal menghapus',
        dueDateToday: 'Hari ini',
        dueDateDaysAgo: '{days} hari lalu',
        dueDateInDays: 'dalam {days} hari'
    },
    item: {
        pageTitle: 'Item',
        searchPlaceholder: 'Cari item Anda',
        addItem: 'Tambah item',
        columnInventoryCountUnit: 'Jumlah Inventaris/Unit',
        noDescription: 'TANPA DESKRIPSI ITEM'
    },
    client: {
        pageTitle: 'Klien',
        searchPlaceholder: 'Cari klien Anda',
        addClient: 'Tambah klien',
        columnClientName: 'Nama Klien',
        columnEmail: 'Email',
        columnPhone: 'Telepon',
        columnBalanceDue: 'Saldo Jatuh Tempo',
        noNameFallback: 'TANPA NAMA'
    },
    expense: {
        pageTitle: 'Pengeluaran',
        searchPlaceholder: 'Cari pengeluaran Anda',
        allCategories: 'Semua kategori',
        noCategory: 'Tanpa Kategori',
        categoryLoadFailed: 'Kategori pengeluaran tidak dapat dimuat.',
        addExpense: 'Tambah pengeluaran',
        columnDescription: 'Deskripsi',
        columnDate: 'Tanggal',
        columnTotal: 'Total',
        tip: 'Tip'
    },
    report: {
        headerTitle: 'Laporan',
        tabDashboard: 'Dasbor',
        tabReportList: 'Daftar laporan',
        export: 'Ekspor',
        annualSalesByClient: 'Penjualan tahunan per klien',
        otherClients: 'Klien lainnya',
        totalOutstandingBalance: 'Total saldo jatuh tempo',
        invoicesCountSuffix: 'faktur',
        byMonth: 'Per bulan',
        byQuarter: 'Per kuartal',
        noSalesFound: 'Tidak ada penjualan ditemukan',
        filterReportTypes: 'Jenis laporan',
        filterTimePeriod: 'Periode waktu',
        filterView: 'Tampilan',
        filterTaxYear: 'Tahun pajak',
        filterQuarter: 'Kuartal',
        filterMonth: 'Bulan',
        filterStartDate: 'Tanggal mulai',
        filterEndDate: 'Tanggal akhir',
        invalidCustomDateRange: 'Tanggal mulai tidak boleh setelah tanggal akhir',
        searchClientName: 'Cari nama klien',
        searchItemName: 'Cari nama item',
        searchSalesJournal: 'Cari nomor faktur atau nama klien',
        searchPaymentsJournal: 'Cari nomor faktur, nama klien, atau jenis pembayaran',
        periodMonth: 'Bulan',
        periodQuarter: 'Kuartal',
        periodYear: 'Tahun',
        periodAllTaxYears: 'Semua Tahun Pajak',
        periodCustom: 'Kustom',
        taxYearLabel: 'Tahun Pajak {year}',
        quarterLabel: 'Q{quarter} Tahun Pajak {year}',
        optionMonthly: 'Bulanan',
        optionQuarterly: 'Kuartalan',
        customerAgingTitle: 'Umur Pelanggan',
        noDataForDateRange: 'Tidak ada data untuk rentang tanggal ini',
        typeSalesByDate: 'Penjualan per Tanggal',
        typeSalesByClient: 'Penjualan per Klien',
        typeSalesByItem: 'Penjualan per Item',
        typeSalesJournal: 'Jurnal Penjualan',
        typePaymentsByDate: 'Pembayaran per Tanggal',
        typePaymentsByClient: 'Pembayaran per Klien',
        typePaymentsByType: 'Pembayaran per Jenis',
        typePaymentsJournal: 'Jurnal Pembayaran',
        typeExpenseByCategory: 'Pengeluaran per Kategori',
        typeExpenseJournal: 'Jurnal Pengeluaran',
        typeProfitLoss: 'Laba Rugi',
        typeTaxes: 'Pajak',
        typeCustomerAging: 'Umur Pelanggan',
        allYears: 'Semua tahun',
        allTime: 'Sepanjang waktu',
        allSales: 'Semua penjualan',
        taxYearSales: 'Penjualan tahun pajak {year}',
        firstColumnMonth: 'Bulan',
        firstColumnQuarter: 'Kuartal',
        firstColumnYear: 'Tahun',
        firstColumnDay: 'Hari',
        firstColumnDate: 'Tanggal',
        columnSubTotal: 'Subtotal',
        columnTax: 'Pajak',
        columnDiscount: 'Diskon',
        columnTotal: 'Total',
        columnAmountPaid: 'Jumlah Dibayar',
        columnAmountOwed: 'Jumlah Hutang',
        columnClient: 'Klien',
        columnItem: 'Item',
        columnUnitType: 'Jenis Unit',
        columnQuantity: 'Kuantitas',
        columnRateAvg: 'Tarif (rata-rata)',
        columnInvoiceDate: 'Tanggal Faktur',
        columnInvoiceNo: 'No Faktur',
        columnType: 'Jenis',
        columnPaymentDate: 'Tanggal Pembayaran',
        columnCategory: 'Kategori',
        columnExpenseDate: 'Tanggal Pengeluaran',
        columnMerchant: 'Pedagang',
        columnDescription: 'Deskripsi',
        columnCurrentDue: 'Jatuh Tempo Saat Ini',
        column1To30DaysOverdue: '1-30 Hari Jatuh Tempo',
        column31To60DaysOverdue: '31-60 Hari Jatuh Tempo',
        column61To90DaysOverdue: '61-90 Hari Jatuh Tempo',
        column91PlusDaysOverdue: '91+ Hari Jatuh Tempo',
        columnSection: 'Bagian',
        columnAmount: 'Jumlah',
        columnPreTaxSales: 'Penjualan Sebelum Pajak',
        columnTaxLabel: 'Nama Pajak',
        columnTaxRate: 'Tarif Pajak',
        columnTotalTax: 'Total Pajak',
        columnPostTaxTotal: 'Total Setelah Pajak',
        profitLossTitle: 'Laba Rugi',
        taxesTitle: 'Pajak',
        profitLossRevenue: 'Pendapatan',
        profitLossExpense: 'Pengeluaran',
        profitLossProfit: 'Laba',
        profitLossCash: 'Kas',
        profitLossAccrued: 'Akrual',
        profitLossAccountsReceivables: 'Piutang Usaha',
        profitLossNone: '[Tidak Ada]',
        profitLossTotalExpenses: 'Total Pengeluaran',
        profitLossCashProfit: 'Laba Kas',
        profitLossAccruedProfit: 'Laba Akrual',
        monthNames: 'Jan, Feb, Mar, Apr, Mei, Jun, Jul, Agu, Sep, Okt, Nov, Des',
        totalRowLabel: 'Total'
    },
    invoiceCreate: {
        pageTitlePrefix: 'Tambah',
        initialDataLoadFailed: 'Pengaturan dokumen tidak dapat dimuat. Pengeditan dan penyimpanan dinonaktifkan.',
        searchSuggestionsLoadFailed: 'Saran pencarian tidak dapat dimuat.',
        invoicePrefix: 'prefiks faktur',
        tabCreate: 'Buat',
        tabPreview: 'Pratinjau',
        tabSendEmail: 'Kirim Email',
        sectionClient: 'Klien',
        addClient: 'Tambah klien',
        dialogClientInfo: 'Informasi klien',
        basicInformation: 'Informasi dasar',
        labelName: 'Nama',
        labelEmail: 'Email',
        labelPhone: 'Telepon',
        billingAddress: 'Alamat penagihan',
        labelLine1: 'Baris 1',
        labelLine2: 'Baris 2',
        labelLine3: 'Baris 3',
        shippingAddress: 'Alamat pengiriman',
        labelShippingName: 'Nama Pengiriman',
        labelNotes: 'Catatan',
        placeholderCreateOrSelect: 'Buat atau pilih satu...',
        placeholderClientNotes: 'Tambahkan catatan tentang klien. Mereka tidak dapat melihatnya',
        sectionItems: 'Item',
        saveToYourItem: 'Simpan ke item Anda',
        stock: 'Stok:',
        placeholderItemCode: 'kode item',
        placeholderQuantity: 'Kuantitas',
        placeholderRate: 'tarif',
        placeholderInputDescription: 'Masukkan deskripsi',
        placeholderInputComment: 'Masukkan Komentar',
        placeholderAddRecipient: 'Tambah penerima',
        cc: 'Cc',
        bcc: 'Bcc',
        placeholderEmailSubject: 'Subjek email',
        placeholderMessage: 'Tulis pesan Anda...',
        labelTo: 'Kepada',
        labelSubject: 'Subjek',
        sectionAttachments: 'Lampiran',
        sectionComment: 'Komentar',
        addItem: 'Tambah item',
        addPhoto: 'Tambah foto',
        addPayment: 'Tambah pembayaran',
        goBack: 'kembali',
        dialogShippingInfo: 'Info pengiriman',
        dialogRecordPayment: 'Catat Pembayaran',
        dialogJobDetails: 'Detail pekerjaan',
        labelAmount: 'Jumlah',
        labelShipDate: 'Tanggal kirim',
        labelShipVia: 'Kirim melalui',
        labelTrackingNumber: 'Nomor pelacakan',
        labelFob: 'FOB',
        columnDate: 'Tanggal',
        columnType: 'Jenis',
        msgClientEmailError: 'kesalahan email klien',
        msgAmountGreaterThanZero: 'Jumlah harus lebih besar dari nol',
        msgInvalidAmount: 'Jumlah harus antara 0 dan 999.999.999.999.999 dengan maksimal 5 angka desimal',
        calculatedAmountOutOfRange: 'Jumlah hasil perhitungan melebihi rentang yang didukung',
        msgTextTooLong: '{field} tidak boleh melebihi {max} karakter',
        msgTextTooLongBytes: '{field} tidak boleh melebihi {max} byte UTF-8',
        msgInvalidJobDetails: 'Detail pekerjaan berisi data yang tidak valid',
        msgMorePaymentThanBalance: 'Pembayaran melebihi saldo jatuh tempo',
        mailSentSuccessfully: 'Email berhasil dikirim',
        cumulativeTaxNotice: 'Web tidak mendukung akumulasi pajak dalam faktur...',
        confirmUnsavedChanges: 'Anda memiliki perubahan yang belum disimpan. Apakah Anda ingin menyimpan atau membuangnya?',
        pdf: 'PDF',
        taxDiscountWithholding: 'Pajak, diskon dan pemotongan',
        purchaseOrder: 'Pesanan Pembelian',
        placeholderPurchaseOrderPrefix: 'prefiks pesanan pembelian',
        placeholderCreditMemoPrefix: 'prefiks memo kredit',
        placeholderEstimatePrefix: 'prefiks estimasi',
        labelStatus: 'Status',
        statusIssued: 'Diterbitkan',
        statusApproved: 'Disetujui',
        statusPending: 'Tertunda',
        statusWithdrawn: 'Ditarik',
        tax: 'Pajak'
    },
    createEstimate: {
        pageTitlePrefix: 'Tambah',
        cumulativeTaxNotice: 'Web tidak mendukung akumulasi pajak dalam estimasi...'
    },
    updateInvoice: {
        pageTitlePrefix: 'Perbarui',
        deletePrefix: 'Hapus',
        confirmDelete: 'Ini akan menghapus faktur. Lanjutkan?',
        cumulativeTaxNotice: 'Faktur ini mengandung pajak kumulatif. Web belum mendukung fungsi ini untuk sementara'
    },
    updateEstimate: {
        pageTitlePrefix: 'Perbarui',
        deletePrefix: 'Hapus',
        confirmDelete: 'Ini akan menghapus {document}. Lanjutkan?',
        cumulativeTaxNotice: 'Estimasi ini mengandung pajak kumulatif. Web belum mendukung fungsi ini untuk sementara'
    },
    createAccount: {
        title: 'Buat Akun',
        placeholderEmail: 'email',
        placeholderPassword: 'Kata sandi',
        placeholderCompanyName: 'Nama Perusahaan',
        createAccountButton: 'Buat akun',
        alreadyHaveAccount: 'Sudah punya akun?',
        signIn: 'Masuk',
        validEmail: 'Silakan masukkan alamat email yang valid',
        validPassword: 'Kata sandi harus 6 karakter atau lebih',
        validCompanyName: 'Silakan isi nama perusahaan Anda',
        companyNameTooLong: 'Nama perusahaan dapat berisi hingga {max} karakter'
    },
    clientCreate: {
        pageTitle: 'Tambah klien',
        basicInformation: 'Informasi dasar',
        labelName: 'Nama',
        placeholderName: 'Masukkan nama...',
        labelEmail: 'Email',
        placeholderEmail: 'Masukkan alamat email...',
        labelPhone: 'Telepon',
        placeholderPhone: 'Masukkan nomor telepon...',
        billingAddress: 'Alamat penagihan',
        labelLine1: 'Baris 1',
        labelLine2: 'Baris 2',
        labelLine3: 'Baris 3',
        shippingAddress: 'Alamat pengiriman',
        sameAsBilling: 'Sama dengan alamat penagihan',
        labelShippingName: 'Nama pengiriman',
        labelShippingLine1: 'Baris 1',
        labelShippingLine2: 'Baris 2',
        labelShippingLine3: 'Baris 3',
        labelNotes: 'Catatan',
        placeholderNotes: 'Tambahkan catatan tentang klien. Mereka tidak dapat melihatnya',
        defaultDiscount: 'Diskon default',
        validDefaultDiscount: 'Masukkan diskon default yang valid',
        validName: 'Silakan masukkan nama klien',
        validEmail: 'Silakan masukkan alamat email yang valid'
    },
    clientUpdate: {
        pageTitle: 'Perbarui klien',
        confirmDelete: 'Ini akan menghapus klien. Lanjutkan?'
    },
    itemCreate: {
        pageTitle: 'Tambah item',
        itemTitle: 'Item',
        labelCost: 'Biaya',
        rateSign: 'Tanda tarif',
        inventorySign: 'Tanda penyesuaian inventaris',
        labelUnit: 'Unit',
        placeholderUnit: 'Unit',
        defaultTaxes: 'Pajak default',
        taxOff: 'mati',
        inventoryTitle: 'Inventaris',
        currentInventory: 'Inventaris saat ini',
        adjustInventory: 'Sesuaikan inventaris',
        increase: 'Tambah',
        decrease: 'Kurangi',
        placeholderQuantity: 'Kuantitas',
        placeholderDateAndTime: 'Tanggal dan waktu',
        placeholderNote: 'Catatan',
        addButton: 'Tambah',
        columnDate: 'Tanggal',
        columnQuantity: 'Kuantitas',
        columnNote: 'Catatan',
        withholdingTitle: 'Pemotongan',
        msgInventoryCannotDisable: 'Inventaris tidak dapat dinonaktifkan setelah diaktifkan',
        msgDescriptionRequired: 'Deskripsi item wajib diisi',
        msgInvalidRate: 'Tarif harus antara -999.999.999.999.999 dan 999.999.999.999.999 dengan maksimal 4 angka desimal',
        msgInvalidCost: 'Biaya harus antara 0 dan 999.999.999.999.999 dengan maksimal 5 angka desimal',
        msgInvalidInventory: 'Kuantitas harus antara 0 dan 999.999.999.999.999 dengan maksimal 5 angka desimal',
        msgInvalidUnit: 'Unit tidak boleh berisi && atau lebih dari 255 karakter',
        msgQuantityRequired: 'Kuantitas diperlukan',
        msgDateRequired: 'Tanggal dan waktu diperlukan'
    },
    itemUpdate: {
        pageTitle: 'Edit item',
        columnInvoice: 'Faktur',
        confirmDelete: 'Ini akan menghapus item. Lanjutkan?'
    },
    createStatement: {
        pageTitle: 'Laporan',
        tabPreview: 'Pratinjau',
        tabSendEmail: 'Kirim Email',
        createAction: 'Buat Laporan',
        from: 'Dari',
        to: 'Sampai',
        invoices: 'Faktur',
        balanceDue: 'Saldo terutang',
        editTitle: 'Edit Laporan',
        startDate: 'Tanggal mulai',
        endDate: 'Tanggal selesai',
        onlyShowUnpaid: 'Hanya tampilkan faktur yang belum dibayar',
        unpaidOnlyActive: 'Laporan ini hanya mencakup faktur yang belum dibayar.',
        dateRequired: 'Tanggal mulai dan tanggal selesai wajib diisi',
        invalidDateRange: 'Tanggal selesai tidak boleh lebih awal dari tanggal mulai'
    },
    time: {
        pageTitle: 'Waktu',
        unbilled: 'Belum ditagih',
        billed: 'Sudah ditagih',
        searchPlaceholder: 'Cari waktu berdasarkan klien atau deskripsi',
        addTime: 'Tambah waktu',
        noTime: 'Belum ada catatan waktu',
        noTimeDescription: 'Buat catatan waktu untuk melacak pekerjaan yang dapat ditagih.',
        noClient: 'Tanpa klien',
        filterAndSort: 'Filter dan urutkan',
        year: 'Tahun',
        groupBy: 'Kelompokkan berdasarkan',
        sortBy: 'Urutkan berdasarkan',
        order: 'Urutan',
        yearly: 'Tahunan',
        quarterly: 'Triwulanan',
        monthly: 'Bulanan',
        ascending: 'Naik',
        descending: 'Turun',
        duration: 'Durasi',
        createTitle: 'Buat catatan waktu',
        editTitle: 'Waktu',
        selectClient: 'Pilih klien',
        start: 'Mulai',
        end: 'Selesai',
        hours: 'jam',
        minutes: 'menit',
        ratePreset: 'Tarif',
        customRate: 'Tarif khusus',
        rateName: 'Nama tarif',
        showRateName: 'Tampilkan nama tarif pada faktur',
        invalidDate: 'Waktu mulai dan selesai wajib diisi',
        endBeforeStart: 'Waktu selesai tidak boleh lebih awal dari waktu mulai',
        invalidDuration: 'Durasi harus sesuai dengan waktu mulai dan selesai',
        invalidRate: 'Tarif harus antara 0 dan 999999999999999 dengan maksimal 5 angka desimal',
        rateNameTooLong: 'Nama tarif tidak boleh lebih dari 255 karakter',
        descriptionTooLong: 'Deskripsi tidak boleh lebih dari 3000 karakter',
        confirmDelete: 'Catatan waktu ini akan dihapus. Lanjutkan?'
    },
    setting: {
        taxInfo: 'Info Pajak',
        taxes: 'Pajak',
        taxYearStarts: 'Tahun pajak dimulai',
        taxYearStartSubtitle: 'Atur hari pertama tahun fiskal',
        rateLabel: 'Tarif(%)',
        abbreviation: 'Singkatan',
        addTax: 'Tambah pajak',
        month: 'Bulan',
        day: 'Hari',
        monthPlaceholder: 'Bulan',
        dayPlaceholder: 'Hari',
        saveTaxYearStart: 'Simpan',
        deleteDialogTitle: 'Hapus',
        confirmDeleteTax: 'Anda yakin menghapus pajak ini?',
        deleteConfirm: 'Hapus',
        taxInfoDialogTitle: 'Info Pajak',
        taxName: 'Nama Pajak',
        standardRate: 'Tarif standar (%)',
        additionalRate: 'Tarif tambahan',
        deleteRateX: 'X',
        addRate: 'Tambah tarif',
        taxType: 'Jenis pajak',
        exclusive: 'Eksklusif',
        inclusive: 'Inklusif',
        close: 'tutup',
        saveTax: 'Simpan pajak',
        cantOpenDetailMessage: 'Pajak ini mengandung pajak kumulatif. Web belum mendukung fungsi ini untuk sementara',
        closeButton: 'Tutup',
        rateIsRequired: 'tarif wajib',
        rateIsRequiredMsg: 'Tarif wajib',
        monthAndDayRequired: 'Bulan dan hari diperlukan',
        additionalRateNumber: 'Tarif tambahan {number} (%)',
        taxNameRequired: 'Nama pajak wajib diisi',
        invalidTaxRate: 'Tarif harus antara 0 dan 999999999999999 dengan maksimal 4 angka desimal',
        duplicateTaxRate: 'Tarif pajak harus unik',
        taxRatesTooLong: 'Terlalu banyak tarif pajak untuk disimpan',
        withholdingNameRequired: 'Singkatan wajib diisi saat pemotongan pajak aktif',
        moreRate: ' tarif lagi',
        moreRates: ' tarif lagi'
    },
    companyInfo: {
        title: 'Info Perusahaan',
        details: 'Detail',
        businessName: 'Nama bisnis',
        businessNamePlaceholder: 'Nama bisnis',
        name: 'Nama',
        phone: 'Telepon',
        email: 'Email',
        businessNumber: 'Nomor Bisnis',
        taxNo: 'No Pajak N°',
        deleteField: 'hapus',
        addNewField: 'Tambah field baru',
        address: 'Alamat',
        line1: 'Baris 1',
        line2: 'Baris 2',
        line3: 'Baris 3',
        currency: 'Mata uang',
        currencyLabel: 'Mata uang',
        symbol: 'Simbol',
        placement: 'Penempatan',
        before: 'Sebelum',
        after: 'Sesudah',
        thousandSymbol: 'Simbol Ribu',
        decimalSymbol: 'Simbol Desimal',
        decimalPlaces: 'Angka Desimal',
        example: 'Contoh',
        terms: 'Ketentuan',
        termsLabel: 'Ketentuan',
        termSameDay: 'Hari yang Sama',
        term7Days: '7 Hari',
        term14Days: '14 Hari',
        term21Days: '21 Hari',
        term30Days: '30 Hari',
        term45Days: '45 Hari',
        term60Days: '60 Hari',
        term90Days: '90 Hari',
        term180Days: '180 Hari',
        term365Days: '365 Hari',
        paymentInfo: 'Info Pembayaran',
        displayOnInvoices: 'Tampilkan di faktur',
        titlePlaceholder: 'Judul',
        jobDetails: 'Detail Pekerjaan',
        deleteJobDetail: 'hapus',
        addNewJobField: 'tambah field baru',
        fieldNameRequired: '{field}: nama bidang wajib diisi',
        reservedCharacters: '{field}: nama bidang tidak boleh memuat : atau &&, dan nilai tidak boleh memuat &&',
        serializedDataTooLong: 'Data {field} melebihi batas basis data',
        textDataTooLong: '{field} melebihi batas basis data'
    },
    default: {
        title: 'Default',
        emailMessage: 'Pesan Email',
        enterDescription: 'Masukkan deskripsi',
        emailCc: 'Email Cc',
        emailBcc: 'Email Bcc',
        emailTip: 'Kirim email sekaligus ke alamat di atas.',
        defaultComments: 'Komentar Default',
        invoice: 'Faktur',
        estimate: 'Estimasi',
        purchaseOrder: 'Pesanan Pembelian',
        creditMemo: 'Memo Kredit',
        emailValidError: 'email valid'
    },
    invoiceDesign: {
        template: 'Templat',
        color: 'Warna',
        labels: 'Label',
        labelInvoice: 'Faktur',
        labelEstimate: 'Estimasi',
        labelPurchaseOrder: 'Pesanan pembelian',
        labelCreditMemo: 'Memo kredit',
        labelReceipt: 'KUITANSI',
        labelTermsFormat: 'Format ketentuan',
        labelBillTo: 'Ditagihkan kepada',
        labelFor: 'Untuk',
        labelDate: 'Tanggal',
        labelInvoiceNo: 'No faktur',
        labelEstimateNo: 'No estimasi',
        labelPoNo: 'No PO',
        labelCreditMemoNo: 'No memo kredit',
        labelDueDate: 'Tanggal jatuh tempo',
        labelTerms: 'Ketentuan',
        labelAmount: 'Jumlah',
        labelCode: 'Kode',
        labelDescription: 'Deskripsi',
        labelQuantity: 'Kuantitas',
        labelRate: 'Tarif',
        labelTax: 'Pajak',
        labelSubtotal: 'Subtotal',
        labelBalanceDue: 'Saldo jatuh tempo',
        labelDiscount: 'Diskon',
        labelNonTaxableItem: 'Item Tidak Kena Pajak',
        labelPaid: 'Dibayar',
        labelShipping: 'Pengiriman',
        labelTotal: 'Total',
        labelIncludes: 'Termasuk',
        labelTotalAmountPaid: 'Total Jumlah Dibayar',
        labelShipDate: 'Tanggal Kirim',
        labelShipTo: 'Kirim kepada',
        labelShipVia: 'Kirim melalui',
        labelTrackingNo: 'No pelacakan',
        labelFob: 'F.O.B',
        prefix: 'Prefiks',
        prefixInvoice: 'Faktur',
        prefixEstimate: 'Estimasi',
        prefixPurchaseOrder: 'Pesanan Pembelian',
        prefixCreditMemo: 'Memo Kredit',
        nextNumber: 'Nomor Berikutnya',
        numberingBeginsAt: 'Penomoran dimulai dari',
        nextNumberInvoice: 'Faktur',
        nextNumberEstimate: 'Estimasi',
        nextNumberPurchaseOrder: 'Pesanan Pembelian',
        nextNumberCreditMemo: 'Memo Kredit',
        options: 'Opsi',
        optionTerms: 'Ketentuan',
        optionDueDate: 'Tanggal Jatuh Tempo',
        optionShippingAddress: 'Alamat pengiriman',
        optionProductCode: 'Kode produk',
        optionQuantityAndRate: 'Kuantitas dan tarif',
        optionUnit: 'Unit',
        optionTax: 'Pajak',
        optionAmount: 'Jumlah',
        optionNonTaxableItemStar: 'Bintang item tidak kena pajak',
        optionDiscount: 'Tampilkan diskon',
        optionTaxBreakdown: 'Rincian Pajak',
        optionPaymentHistory: 'Riwayat pembayaran',
        optionStamp: 'Stempel',
        optionPageNumber: 'Nomor Halaman',
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewShipName: 'Peter',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewThanksMessage: 'Terima kasih atas bisnis Anda! Kami berharap Anda puas dengan pekerjaan kami. Silakan kirim pembayaran dalam 15 hari. Pertanyaan? Komentar? Hubungi kami di (111)111-1234 atau email kami di example@owner.com, kami dengan senang hati menjawab pertanyaan atau kekhawatiran apa pun.',
        previewSubtotal: 'Subtotal',
        previewVat: 'VAT 17.00%',
        previewPayment1: 'Pembayaran pada Oct 1, 2019',
        previewPayment2: 'Pembayaran pada Oct 2, 2019',
        invalidNextNumber: 'Setiap nomor berikutnya harus berupa bilangan bulat antara 0 dan {max}'
    },
    feedback: {
        title: 'Kirim Umpan Balik',
        invalidEmailNoticePrefix: 'Alamat email pada akun Anda tidak valid, sehingga kami tidak dapat menghubungi Anda. Silakan kirim umpan balik Anda dari alamat email yang valid ke',
        invalidEmailNoticeSuffix: 'Jika memungkinkan, sertakan tangkapan layar isu tersebut; itu akan membantu kami menyelidiki dan menyelesaikannya.',
        replyTip: 'Setelah mengirim, silakan periksa email Anda untuk balasan.',
        contextTip: 'Detail akun dan browser berikut akan disertakan bersama umpan balik Anda:',
        content: 'Konten',
        enterDescription: 'Masukkan deskripsi',
        contentTooLong: 'Konten tidak boleh melebihi {max} karakter'
    },
    createExpense: {
        title: 'Tambah Pengeluaran',
        description: 'Deskripsi',
        expenseDescriptionPlaceholder: 'Deskripsi pengeluaran',
        total: 'Total',
        tax: 'Pajak',
        tip: 'Tip',
        expenseDate: 'Tanggal Pengeluaran',
        merchant: 'Pedagang',
        merchantPlaceholder: 'Masukkan nama pedagang',
        categoryPlaceholder: 'Pilih kategori',
        addNewCategory: 'Tambah kategori baru',
        deletePhoto: 'Hapus',
        addPhoto: 'Tambah foto',
        deleteCategory: 'hapus',
        addCategory: 'Tambah kategori',
        descriptionTooLong: 'Deskripsi tidak boleh lebih dari 3.000 karakter.',
        merchantTooLong: 'Nama pedagang tidak boleh lebih dari 255 karakter.',
        amountInvalid: 'Total, pajak, dan tip masing-masing harus antara 0 dan 999999999999999, dengan maksimal 5 angka desimal.',
        categoryRequired: 'Nama kategori wajib diisi.',
        categoryTooLong: 'Nama kategori tidak boleh lebih dari 255 karakter.',
        photoUploadFailed: 'Foto gagal diunggah. Silakan coba lagi.'
    },
    updateExpense: {
        title: 'Perbarui Pengeluaran',
        deleteExpense: 'Hapus Pengeluaran',
        confirmDeleteMsg: 'Ini akan menghapus pengeluaran. Lanjutkan?'
    },
    notFound: {
        oops: 'WADUH!',
        notFoundMsg: 'Sepertinya kami tidak dapat menemukan halaman yang Anda cari.',
        takeMeHome: 'Bawa saya ke beranda'
    },
    classicPDF: {
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewDueDate: 'Nov 15,2019',
        previewShipName: 'Peter',
        previewFreeShipping: 'Pengiriman Gratis',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewItem1: 'Komputer',
        previewItem2: 'Telepon',
        previewItem3: 'Kue ulang tahun',
        previewTaxRate: '17%',
        nonTaxableNote: '* Menunjukkan item tidak kena pajak',
        thanksMessage: 'Terima kasih atas bisnis Anda! Kami berharap Anda puas dengan pekerjaan kami. Silakan kirim pembayaran dalam 15 hari. Pertanyaan? Komentar? Hubungi kami di (111)111-1234 atau email kami di example@owner.com, kami dengan senang hati menjawab pertanyaan atau kekhawatiran apa pun.',
        subtotal: 'Subtotal',
        vat: 'VAT 17.00%',
        payment1: 'Pembayaran pada Oct 1, 2019',
        payment2: 'Pembayaran pada Oct 2, 2019',
        balanceDue: 'Saldo Jatuh Tempo'
    }
};
